import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Stat = {
	name: NAME,
	apiProvider,
	router,
};
